
<template>
  <div class="com-card-placeholder" :style="dataInfo.placeholder_style"></div>
</template>

<script>
import { CptMixin } from '../../../mixins/CptMixin'
export default {
  mixins: [CptMixin]
}
</script>

<style lang="less">
.com-card-placeholder {
  position: relative;
  margin-top: 12px;
  border-radius: 8px;
  background: rgba(250, 251, 252, 1);
  &::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border-radius: 16px;
    border: 1px solid rgba(243, 244, 245, 1);
    transform: scale(.5);
    transform-origin: left top;
    pointer-events: none;
  }
}
</style>